import { Component } from "react";

export default class Notfound extends Component {
  render() {
    return <div>notfound</div>;
  }
}
